import { render, staticRenderFns } from "./xiaoXiangReceiptRecordTj.vue?vue&type=template&id=0ec7cd30"
import script from "./xiaoXiangReceiptRecordTj.vue?vue&type=script&lang=js"
export * from "./xiaoXiangReceiptRecordTj.vue?vue&type=script&lang=js"
import style0 from "./xiaoXiangReceiptRecordTj.vue?vue&type=style&index=0&id=0ec7cd30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports